<style lang="scss" scoped="top-header">
  @import "./style.scss"
</style>

<template>
    <div class="top-header" v-if="$store.state.isPc">
    	<img class="logo" src="../../../assets/logo.png" />
    	<el-menu
				  :default-active="$store.state.menuActive"
				  class="el-menu-demo"
				  mode="horizontal"
				  background-color="#15185f"
				  text-color="#fff"
				  active-text-color="#fff"
				  @select="handleSelect">
			  <el-menu-item index="home">首页</el-menu-item>
			  <el-menu-item index="product">产品</el-menu-item>
			  <el-menu-item index="solution">解决方案</el-menu-item>
			  <el-menu-item index="contact">联系我们</el-menu-item>
			</el-menu>
    </div>
    <div class="top-header" v-else>
    	<img class="logo" src="../../../assets/logo.png" />
    </div>
</template>

<script>
import script from './script.js'
export default script
</script>



// WEBPACK FOOTER //
// src/views/common/header/index.vue